// extracted by mini-css-extract-plugin
module.exports = {"button":"Q_ETZHXHkkAHDMxTr34dZ","link":"_2CGN3KGBt7atju4jkIHuKx"};